export const LIST_BANK_FEES         = 'LIST_BANK_FEES';
export const CHANGE_VALUES_FORM_FEE = 'CHANGE_VALUES_FORM_FEE';
export const SAVE_FORM_FEE          = 'SAVE_FORM_FEE';
export const GET_ITEM_BANK_FEE      = 'GET_ITEM_BANK_FEE';
export const DELETE_ITEM_BANK_FEE   = 'DELETE_ITEM_BANK_FEE';
export const UPLOAD_LOGO_BANK_FEE   = 'UPLOAD_LOGO_BANK_FEE';
export const BANK_FEE_DEFAULT_DATA  = 'BANK_FEE_DEFAULT_DATA';